import React from "react";
import TablePaginationFooter from "../table/TablePaginationFooter";

function PaginatedView({
  path,
  query = null,
  current,
  total,
  pageSize,
  totalItems,
  currentItemCount,
}) {
  return (
    <div className="overflow-hidden rounded-lg border border-slate-200 bg-white shadow-sm">
      <TablePaginationFooter
        routePath={path}
        query={query ?? ""}
        currentPage={current ?? 0}
        totalPages={total ?? 0}
        pageSize={pageSize}
        totalItems={totalItems}
        currentItemCount={currentItemCount}
      />
    </div>
  );
}

export default PaginatedView;
